import api from '@/api';
import { Product } from '../types';

export async function getCategoryProducts(categoryId: string) {
  const response = await api.get<{
    data: Product[];
  }>('/products', {
    params: {
      populate: ['medias.media', 'characteristics'],
      filters: {
        category: {
          id: categoryId
        }
      },
      pagination: {
        limit: 99999
      },
      sort: ['title:asc']
    }
  });

  return response.data;
}

export async function getProduct(id: string) {
  const response = await api.get<{
    data: Product;
  }>(`/products/${id}`, {
    params: {
      populate: ['category.id', 'medias.media', 'characteristics.value', 'machines']
    }
  });

  return {
    ...response.data,
    media: response.data.data.attributes.medias.map(media => {
      if ('video' in media) {
        return {
          ...media
          // video: JSON.parse(media.video)
        };
      }

      return media;
    })
  };
}

// TODO: добавить пагинацию
export async function getProductsForMachine({
  machineId,
  categoryId
}: {
  machineId: number;
  categoryId: number;
}): Promise<
  {
    in_stock: number;
    price: number;
    product: Product;
  }[]
> {
  const response = await api.get<{
    data: {
      in_stock: number;
      price: number;
      product: Product;
    }[];
  }>(`/products/machine/${machineId}`, {
    params: {
      populate: ['products.product'],
      categoryId,
      pagination: {
        limit: 99999
      }
    }
  });

  // Преобразуем данные в нужный формат
  return response.data.data;
}
